import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-2",
  "data-testid": "qualification-missing-list"
}
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2 text-sm" }
const _hoisted_4 = { class: "font-semibold text-textPrimary" }

import { mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import { ProfessionalDocumentStatus } from '@/types/professional-documents.types'
import { QualificationOnFail } from '@/types/qualification-eligibility.types'
import type { EligibilityReason } from '@/types/qualification-eligibility.types'

import { ON_FAIL_LABEL, missingStatusText } from './qualificationText'


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationMissingList',
  props: {
    missing: {}
  },
  setup(__props: any) {



const isBlocking = (reason: EligibilityReason) => reason.onFail === QualificationOnFail.BLOCK

const catalog = useProfessionalDocumentCatalogStore()
catalog.ensureLoaded().catch(() => {
  // fallback intencional: sem catálogo cada item mostra a própria chave (`reasonName` cai nela),
  // então o item segue visível; o erro fica em `catalog.loadError` (R48.2).
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missing, (reason) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `${reason.field}-${reason.key}`,
        class: _normalizeClass(["flex flex-wrap items-center justify-between gap-2 rounded-lg border bg-white px-3 py-2", isBlocking(reason) ? 'border-negative/40' : 'border-alert/40']),
        "data-testid": `qualification-missing-${reason.field}-${reason.key}`
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(catalog).reasonName(reason)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["rounded px-1.5 py-0.5 text-xs font-semibold", 
            reason.status === _unref(ProfessionalDocumentStatus).IN_REVIEW
              ? 'bg-primary5 text-primary40'
              : 'bg-red-50 text-negative'
          ])
          }, _toDisplayString(_unref(missingStatusText)(reason)), 3)
        ]),
        _createVNode(LabelBadge, {
          label: _unref(ON_FAIL_LABEL)[reason.onFail],
          color: isBlocking(reason) ? 'red' : 'orange',
          icon: isBlocking(reason) ? _unref(mdiLockOutline) : _unref(mdiClockOutline),
          size: "small"
        }, null, 8, ["label", "color", "icon"])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})